import React from 'react';
import PropTypes from 'prop-types';
import {default as ImageUI} from '@spothero/ui/image';
import withConfig from 'config/withConfig';

const Image = ({cloudinaryCloudName, ...props}) => {
    return <ImageUI cloudinaryCloudName={cloudinaryCloudName} {...props} />;
};

Image.propTypes = {
    cloudinaryCloudName: PropTypes.string,
};

export default withConfig(['cloudinaryCloudName'])(Image);
